(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sunice-category-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sunice-category-carousel')) {
    customElements.define('sunice-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.sunice-categories__track');
        this.previous = this.querySelector('[data-category-previous]');
        this.next = this.querySelector('[data-category-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
          }
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      behavior() {
        return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(direction) {
        const item = this.track.querySelector('.sunice-categories__item');
        if (!item) return;
        const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        const count = Math.max(1, Math.floor(this.track.clientWidth / step));
        this.track.scrollBy({ left: direction * step * count, behavior: this.behavior() });
      }
      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const overflows = maxScroll > 2;
        this.previous.hidden = !overflows;
        this.next.hidden = !overflows;
        this.previous.disabled = !overflows || this.track.scrollLeft <= 2;
        this.next.disabled = !overflows || this.track.scrollLeft >= maxScroll - 2;
        const media = this.track.querySelector('.sunice-categories__media');
        if (media) this.style.setProperty('--category-arrow-top', `${media.offsetTop + media.offsetHeight / 2}px`);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sunice-gender-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sunice-gender-filter')) {
    customElements.define('sunice-gender-filter', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-gender-value]');
          if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const param = this.dataset.genderParam;
          if (!param) return;
          event.preventDefault();
          const value = link.dataset.genderValue;
          const url = new URL(window.location.href);
          url.searchParams.delete('page');
          url.searchParams.delete('ajax_page');
          url.searchParams.delete(param);
          if (value) url.searchParams.set(param, value);
          const sectionRoot = this.closest('.shopify-section') || document;
          sectionRoot.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
            if (input.name === param) input.checked = Boolean(value) && input.value === value;
          });
          this.querySelectorAll('[data-gender-value]').forEach(item => {
            if (item === link) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });
          const form = sectionRoot.querySelector('facets-form-component');
          if (form && typeof form.updateFiltersByURL === 'function') form.updateFiltersByURL(url.toString());
          else window.location.assign(url.toString());
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
